/* models/widgets/input_group */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    var control_1 = require(445) /* ./control */;
    var InputGroupView = /** @class */ (function (_super) {
        tslib_1.__extends(InputGroupView, _super);
        function InputGroupView() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        InputGroupView.prototype.connect_signals = function () {
            var _this = this;
            _super.prototype.connect_signals.call(this);
            this.connect(this.model.change, function () { return _this.render(); });
        };
        InputGroupView.__name__ = "InputGroupView";
        return InputGroupView;
    }(control_1.ControlView));
    exports.InputGroupView = InputGroupView;
    var InputGroup = /** @class */ (function (_super) {
        tslib_1.__extends(InputGroup, _super);
        function InputGroup(attrs) {
            return _super.call(this, attrs) || this;
        }
        InputGroup.__name__ = "InputGroup";
        return InputGroup;
    }(control_1.Control));
    exports.InputGroup = InputGroup;
}
